import { render, staticRenderFns } from "./CorpWalletActivities.vue?vue&type=template&id=3171aba8&"
import script from "./CorpWalletActivities.vue?vue&type=script&lang=ts&"
export * from "./CorpWalletActivities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports